<template>
  <div class="page-firm-list main-page">
    <Menus title="律师律所">
      <template slot="left-link">
        <a href="javascript:;"
           @click="goPrevious()"></a>
      </template>
    </Menus>
    <div class="container-flex">
      <div class="firm-search-panel  ">

        <div class="input-panel">
          <input type="text"
                 v-model="searchForm.zwmc"
                 placeholder="律所中文名/统一社会信用代码">
          <button class="flex justify-center items-center flex-shrink-0 text-lg"
                  @click="getSearch"> <img src="https://qiniu.laway.cn/yn/2025/02/08/f8648f40e5c411ef99f8b4055d0b07be.svg"
                 class="mr-[4px]"> 搜索</button>
        </div>
        <div class="search-params">
          <div class="hts">高级检索</div>
          <div class="params-item">
            <div class="params-item-title">所在地区：</div>
            <div class="params-item-content">
              <div @click="searchForm.city = '';searchForm.code=''"
                   :class="['radio-item  ',{active:!searchForm.city}]">
                <input type="radio">
                不限
              </div>
              <div @click="searchForm.city = key;searchForm.code=''"
                   :class="['radio-item  ',{active:searchForm.city==key}]"
                   v-for="(city, key) in arealist"
                   :key="'key-c' + key">
                <input type="radio"
                       v-model="searchForm.code">
                {{city.alias}}
              </div>
            </div>
          </div>
          <div class="params-item"
               v-if="arealist[searchForm.city]">
            <div class="params-item-title">所在区县：</div>
            <div class="params-item-content">
              <div @click="searchForm.code=''"
                   :class="['radio-item  ',{active:!searchForm.code}]">
                <input type="radio"
                       v-model="searchForm.code">
                不限
              </div>
              <div @click="searchForm.code = key"
                   :class="['radio-item  ',{active:searchForm.code==key}]"
                   v-for="(v, key) in arealist[searchForm.city].children"
                   :key="'key-c' + key">
                <input type="radio"
                       v-model="searchForm.code">
                {{v.alias}}
              </div>
            </div>
          </div>

          <div class="params-item">
            <div class="params-item-title">组织形式：</div>
            <div class="params-item-content">
              <div @click="searchForm.zzxs=''"
                   :class="['radio-item ',{active:!searchForm.zzxs}]">
                <input type="radio"
                       value="">
                不限
              </div>
              <div @click="searchForm.zzxs=v.id"
                   v-for="(v, key) in firmDefine.zzxs_data"
                   :key="'key-c' + key"
                   :class="['radio-item ',{active:searchForm.zzxs==v.id}]">
                <input type="radio"
                       :value="v.id">
                {{ v.name }}
              </div>

            </div>
          </div>
          <div class="params-item">
            <div class="params-item-title">律师人数：</div>
            <div class="params-item-content">
              <div @click="searchForm.lsrs=''"
                   :class="['radio-item ',{active:!searchForm.lsrs}]">
                <input type="radio"
                       value="">
                不限
              </div>
              <div @click="searchForm.lsrs=1"
                   :class="['radio-item ',{active:searchForm.lsrs==1}]">
                <input type="radio"
                       value="">
                10人以下
              </div>
              <div @click="searchForm.lsrs=2"
                   :class="['radio-item ',{active:searchForm.lsrs==2}]">
                <input type="radio"
                       value="">
                10-30人
              </div>
              <div @click="searchForm.lsrs=3"
                   :class="['radio-item ',{active:searchForm.lsrs==3}]">
                <input type="radio"
                       value="">
                30-50人
              </div>
              <div @click="searchForm.lsrs=4"
                   :class="['radio-item ',{active:searchForm.lsrs==4}]">
                <input type="radio"
                       value="">
                50-100人
              </div>
              <div @click="searchForm.lsrs=5"
                   :class="['radio-item ',{active:searchForm.lsrs==5}]">
                <input type="radio"
                       value="">
                100人以上
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="firm-list-panel">
        <div class="lawfirm-list">
          <div class="item"
               v-for="(lawfirm, index) in list"
               :key="'key-' + index"
               @click="toLawfirmDetail(lawfirm)">
            <div class="content">
              <div class="name">{{ lawfirm.zwmc }}</div>
              <div>{{ lawfirm.lsdz }}<br>
                <span v-if="lawfirm.tell">电话：{{ lawfirm.tell }}</span>
                <span v-else>电话：暂无</span>
              </div>
            </div>
            <i class="glyphicon glyphicon-chevron-right"></i>
          </div>

          <button v-if="loadOver &&  list.length &&pageSize>page"
                  class="more-btn"
                  @click="getMore">加载更多</button>
          <div v-if="loadOver&& !list.length"
               class="empty-info">
            <img src="https://qiniu.laway.cn/yn/2020/11/10/e0a5a0ac22fe11eb8cd1b4055d0b07be.png"
                 class="mx-auto"
                 alt="">
            <p>没有搜索到~</p>
          </div>
        </div>
      </div>
      <div class="lawfirm-detail"
           v-if="step == 1">
        <div class="lawfirm-detail-content"
             :style="only_lawfirm_css">
          <div class="name">{{ currentlawfirm.zwmc }}</div>

          <div class="info"
               v-html="currentlawfirm.lsdz">
          </div>
          <div class="more">
            <a href="javascript:void(0)"
               class="btn btn-primary"
               @click="step = 2"
               v-if="currentlawfirm.content">律所详情</a>
          </div>
          <div class="contact">
            <div>
              组织形式：{{ currentlawfirm.zzxs }}
            </div>
            <div>
              批准设立时间：{{ currentlawfirm.pzslsj }}
            </div>
            <div>
              统一社会信用代码：{{ currentlawfirm.tyshxydm }}
            </div>
            <div>
              {{ currentlawfirm.address }}
            </div>
            <div v-if="currentlawfirm.tell">

              电话：{{ currentlawfirm.tell }}</div>
            <div v-else>

              电话：暂无</div>
          </div>
          <div class="ht">律所律师</div>

          <div class="lawyer-list">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-4"
                     v-for="(lawyer, index) in currentlawyerlist"
                     :key="'key-' + index">
                  <a href="javascript:void(0)"
                     class="item"
                     @click="toLawyerDetail(lawyer)">
                    <div v-if="lawyer.zp"
                         class="imgs"
                         :style="'background-image:url(' + lawyer.zp + ')'"></div>
                    <div v-else
                         class="imgs"
                         style="background-image:url('/img/ui/lawyer_avatar.png')"></div>
                    <div class="c">
                      <div class="lawyer-name">{{ lawyer.mc }}</div>
                      <div class="lawyer-tell"
                           v-if="lawyer.lxfs">联系电话：{{ lawyer.lxfs }}</div>
                      <div class="lawyer-tell"
                           v-else>联系电话：暂无</div>
                      <div class="lawyer-intro">
                        执业证号：{{ lawyer.zyzh }}
                      </div>
                      <div class="lawyer-intro">
                        执业类别：{{ lawyer.zylb }}
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mask"
             @click="step = 0"></div>
      </div>
      <div class="lawyer-about"
           v-if="step == 3">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="lawyer">
                <div class="content">
                  <div class="imgs"
                       :style="'background-image:url('+currentlawyer.zp||+'/img/ui/lawyer_avatar.png)'"></div>
                  <div class="intro">
                    <strong class="name">{{ currentlawyer.xm }}</strong>

                    <div class="lawfir">{{ currentlawfirm.zwmc }}</div>
                  </div>
                  <div class="sc">
                    <ul>
                      <li>执业证号：{{ currentlawyer.zyzh }}</li>
                      <li style="width:100%">执业年限：-</li>
                      <li style="width:100%">联系电话：{{currentlawyer.lxfs||'-'}}</li>
                      <li style="width:100%">执业类别：{{ currentlawyer.zylb || '-' }}</li>
                      <li style="width:100%">执业机构：{{ currentlawfirm.zwmc || '-' }}</li>
                      <li style="width:100%">工作地址：{{ currentlawfirm.lsdz || '-' }}</li>
                      <li style="width:100%">擅长业务：{{ currentlawyer.adept || '-' }}</li>
                    </ul>
                  </div>
                </div>
                <div class="body"
                     v-if="currentlawyer.desc">
                  <div class="ht">
                    律师简介
                  </div>
                  <div class="detail"
                       v-html="currentlawyer.desc">
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu.vue'
import { LAWFIRM_INQUIRE } from '@/datas/constants/statistics.js'
const lsrsDefine = {
  1: [0, 10],
  2: [10, 30],
  3: [30, 50],
  4: [50, 100],
  5: [100, 100000],
}
export default {
  components: { Menus },
  data () {
    return {
      curType: 2,
      searchForm: {
        city: '',
        code: '',
        xb: '',
        zwmc: '',
        mc: '',
        zzxs: '',
        lsrs: 0
      },
      page: 1,
      pageSize: 0,
      lawyerDefine: '',
      firmDefine: '',
      list: [],
      currentlawyerlist: [],
      loadOver: false,
      step: 0,
      currentlawfirm: ''
    }
  },
  computed: {
    arealist () {
      return this.$store.state.device.area
    },
    only_lawfirm_css () {
      const c = this.config
      return c && c.lawfrim_filter ? 'left:0;padding:40px 200px' : 'left:30%'
    },

  },
  watch: {
    searchForm: {
      deep: true,
      handler (val) {
        this.searchForm.zwmc = this.searchForm.zwmc.trim()
      }
    },
  },
  created () {
    this.$root.getStatistics(LAWFIRM_INQUIRE)
    const { zwmc, code, city, lsrs, zzxs } = this.$route.query
    this.searchForm = {
      ...this.searchForm,
      zwmc, code, city, lsrs, zzxs
    }
    this.getDefine()
    this.getList()
  },

  methods: {
    async getDefine () {

      const res = await this.$api.getLawfirmDefine()
      this.firmDefine = res
    },
    getSearch () {
      let { zwmc } = this.searchForm
      if (zwmc.length < 2) {
        this.$alert(zwmc.length ? '至少输入两位关键字' : '请输入律师事务所中文名/统一社会信用代码')
        return
      }
      this.page = 1
      this.getList()
    },
    async getList () {
      let { zwmc, code, city, zzxs } = this.searchForm
      if (zwmc.length < 2) return
      const params = {
        zwmc,
        page: this.page,
        code: code || city,
        zzxs,
      }
      const lsrs = lsrsDefine[this.searchForm.lsrs]
      if (lsrs) {
        params.num_begin = lsrs[0]
        params.num_end = lsrs[1]
      }
      const result = await this.$api.lsLawfirm({
        params
      })
      this.list = this.page > 1 ? [...this.list, ...result.data] : result.data
      this.pageSize = result.num_pages
      this.loadOver = true
    },
    toLawfirmDetail (lawfirm) {
      this.step = 1
      this.currentlawfirm = lawfirm
      this.getLawyer(this.currentlawfirm)
    },
    async getLawyer (lawfirm) {
      const params = {
        firm: lawfirm.bh,
        per_page: 100000,
        page: 1
      }
      let result = await this.$api.lsLawyer({ params })
      this.currentlawyerlist = result.data
    },
    toLawyerDetail (lawyer) {
      this.step = 3
      this.currentlawyer = lawyer
    },
    getMore () {
      this.page++
      this.getList()
    },
    goPrevious () {
      this.step === 0 ? this.$router.go(-1) : this.step = 1
    }
  }
}
</script>
<style lang="stylus" scoped>
.page-firm-list
  color #fff
  .container-flex
    display flex
    color #333
  .firm-search-panel
    width 25%
    padding 0.2rem
    background #fff
    height 100%
    .input-panel
      position relative
      margin-top 0.1rem
      border-radius 0.1rem
      overflow hidden
      display flex
      background #fff
      border 1px solid #378bf8
      input
        font-size 0.18rem
        padding 0 0.2rem
        flex 1
        border 0
      input:-moz-placeholder, input::-moz-placeholder
        color #999
        opacity 1
      input:-ms-input-placeholder
        color #999
      input::-webkit-input-placeholder
        color #999
      button
        width 1rem
        height 0.45rem
        font-size 0.2rem
        color #fff
        background-color #2a69e0
    .search-params
      padding-top 0.2rem
      .hts
        font-size 0.2rem
        font-weight bold
        letter-spacing 1px
        color #333
        margin-bottom 0.1rem
      .params-item
        display flex
        align-items baseline
        margin-bottom 0.1rem
        .params-item-title
          font-size 0.18rem
          width 0.9rem
          flex-shrink 0
          text-align right
        .params-item-content
          flex 1
          display flex
          font-size 0.22rem
          flex-wrap wrap
          padding-left 0.1rem
    .radio-item
      letter-spacing 1px
      margin-bottom 0.1rem
      font-size 0.18rem
      margin-right 0.2rem
      input
        width 12px
        height 12px
        cursor pointer
        margin-right 2px
        border-radius 2px
        border solid 1px #e6e6e6
      &.active
        color #f29530
        input
          position relative
          border-color #f29530
          &::after
            content ''
            position absolute
            top -1px
            left 1px
            width 5px
            height 8px
            border-left solid #f29530 1px
            border-top solid #f29530 1px
            transform rotate(225deg)
  .firm-list-panel
    flex 1
    overflow hidden
    .lawfirm-list
      height 100%
      padding-left 0.2rem
      padding-right 0.4rem
      overflow-y auto
      .item
        display block
        background #fff
        margin-bottom 0.2rem
        padding 0.25rem 0.4rem 0.25rem 0.25rem
        font-size 0.16rem
        color #808080
        border-radius 0.05rem
        display flex
        align-items center
        &:active
          background #f7f7f7
        .content
          flex 1
          .name
            color #555
            font-size 0.24rem
            padding-bottom 0.1rem
        .glyphicon
          flex-shrink 0
          font-size 0.24rem
          color #ddd
    .more-btn
      width 2rem
      margin 0.1rem auto 0.2rem
      display block
      background #fff
      font-size 0.2rem
      padding 0.1rem
      border-radius 0.1rem
      color #2a69e0
    .empty-info
      text-align center
      color #fff
      padding-top 1rem
      img
        margin-bottom 0.3rem
  .lawfirm-detail
    .lawfirm-detail-content
      position fixed
      top 1.2rem
      right 0
      bottom 0
      left 27%
      background #fff
      z-index 2000
      padding 0.4rem
      overflow-y scroll
      font-size 0.16rem
      .name
        font-size 0.28rem
        padding-bottom 0.2rem
      .more
        padding 0.2rem 0
      .info
        display -webkit-box
        -webkit-box-orient vertical
        -webkit-line-clamp 3
        overflow hidden
        p
          margin-bottom 0
          display none
          &:first-child
            display block
      .ht
        font-size 0.2rem
        color #555
        line-height 1
        border-left 0.05rem solid #558ce1
        padding-left 0.1rem
        margin 0.35rem 0 0.15rem
    .lawyer-list
      margin-left -0.15rem
      padding-bottom 0.8rem
      .item
        border 0.01rem solid #eee
        padding 0.25rem
        display flex
        margin-bottom 0.3rem
        &:active
          background #f7f7f7
        .imgs
          width 0.72rem
          height 0.72rem
          background-size cover
          background-position center 0
          flex-shrink 0
          border-radius 50%
          margin-right 10px
        .lawyer-name
          font-size 0.18rem
          color #333
        .lawyer-tell
          font-size 0.14rem
          color #808080
          display -webkit-box
          -webkit-box-orient vertical
          -webkit-line-clamp 1
          overflow hidden
        .lawyer-intro
          font-size 0.14rem
          color #808080
          display -webkit-box
          -webkit-box-orient vertical
          -webkit-line-clamp 1
          overflow hidden
    .contact
      padding-bottom 0.15rem
      border-bottom 0.01rem solid #ddd
      div
        margin-bottom 0.1rem
        display flex
        align-items center
        span
          color #558ce1
          display inline-flex
          align-items center
    .mask
      position fixed
      top 0
      left 0
      right 0
      bottom 0
      background rgba(0, 0, 0, 0.5)
      z-index 1000
  .lawyer-about
    position fixed
    left 0
    right 0
    bottom 0
    top 1.2rem
    overflow-y scroll
    z-index 2100
    background #ddd
    .lawyer
      padding-bottom 1.2rem
      .btn-zxls
        display flex
        justify-content center
        align-items center
        height 0.6rem
        font-size 0.24rem
        margin 40px 20% 0
      .content
        margin 1rem 0 0.1rem
        border-radius 0.05rem
        position relative
        border-bottom 0.01rem solid #ddd
        .imgs
          position absolute
          top -0.75rem
          left 50%
          margin-left -0.75rem
          width 1.5rem
          height 1.5rem
          border 0.03rem solid #fff
          border-radius 50%
          background-size cover
          background-color #fff
          background-position center 0
          box-shadow 0 0.03rem 0.05rem rgba(0, 0, 0, 0.3)
        .sc
          background #fff
          padding 0.35rem
          border-radius 0 0 0.05rem 0.05rem
          color #808080
          font-size 0.2rem
          ul
            display flex
            flex-wrap wrap
            li
              width 50%
              padding-bottom 20px
        .tel
          display flex
          justify-content center
          align-items center
          padding 0.15rem
          border-radius 0 0 0.05rem 0.05rem
          color #999
          .icon
            color #4caf50
      .body
        background #fff
        padding 0.25rem
        min-height 0.7rem
        color #555
        border-radius 0.05rem
        border-bottom 0.01rem solid #ddd
        .ht
          border-bottom 0.01rem solid #eee
          padding-bottom 0.1rem
          margin-bottom 0.1rem
          font-size 0.24rem
          font-weight bold
        .detail
          padding 0.3rem
          font-size 0.18rem
      .intro
        padding 1.05rem 0.15rem 0.5rem
        border-radius 0.05rem 0.05rem 0 0
        background #1488cc
        /* fallback for old browsers */
        background -webkit-linear-gradient(to right, #2b32b2, #1488cc)
        /* Chrome 10-25, Safari 5.1-6 */
        background linear-gradient(to right, #2b32b2, #1488cc)
        /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        .name
          display block
          text-align center
          color #fff
          font-size 0.36rem
          margin-bottom 0.05rem
        .lawfir
          padding-top 0.1rem
          color #fff
          opacity 0.6
          text-align center
          font-size 0.18rem
        .rate
          text-align center
          font-size 0.24rem
          color rgba(255, 255, 255, 0.2)
          .on
            color #fff100
          span
            color #fff
            padding 0 0.15rem
</style>